import React from 'react';
import {motion} from 'framer-motion';
import {Link} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiArrowLeft} = FiIcons;

const RevocationPage = () => (
  <div className="min-h-screen bg-gradient-to-b from-slate-50 to-stone-100 py-16 px-4 sm:px-6 lg:px-8">
    <div className="max-w-4xl mx-auto">
      <motion.div
        initial={{opacity: 0, y: 30}}
        animate={{opacity: 1, y: 0}}
        transition={{duration: 0.8}}
      >
        <Link
          to="/"
          className="inline-flex items-center text-amber-700 hover:text-amber-800 mb-8 transition-colors"
        >
          <SafeIcon icon={FiArrowLeft} className="w-4 h-4 mr-2" />
          Zurück zur Startseite
        </Link>

        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-6 py-8 rounded-t-2xl border border-stone-200">
          <h1 className="text-4xl font-bold text-stone-800">
            Widerrufsrecht
          </h1>
        </div>

        <div className="bg-white p-12 rounded-b-2xl shadow-lg border-l border-r border-b border-stone-200">
          <div className="prose prose-stone max-w-none space-y-6 text-stone-700">
            <p className="leading-relaxed">
              Unsere Kurse und Retreats finden zu festen Terminen statt. Für
              Verträge über Dienstleistungen im Zusammenhang mit
              Freizeitbetätigungen, die für einen bestimmten Termin vorgesehen
              sind, besteht nach § 312g Absatz 2 Nummer 9 BGB kein gesetzliches
              Widerrufsrecht. Für Buchungen von Kursen und Retreats gelten daher
              unsere Stornobedingungen.
            </p>

            <p className="leading-relaxed">
              Beim Kauf eines Gutscheins ist noch kein Termin vereinbart. Hier
              besteht ein gesetzliches Widerrufsrecht.
            </p>

            <section>
              <h2 className="text-2xl font-bold text-stone-800 mb-4">
                Widerrufsbelehrung für Gutscheine
              </h2>

              <p className="leading-relaxed">
                Sie haben das Recht, binnen 14 Tagen ohne Angabe von Gründen
                diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt 14 Tage
                ab dem Tag des Vertragsschlusses.
              </p>

              <p className="leading-relaxed">
                Um Ihr Widerrufsrecht auszuüben, informieren Sie uns mit einer
                eindeutigen Erklärung – formlos per E-Mail oder Brief – über
                Ihren Entschluss, den Vertrag zu widerrufen:
              </p>

              <p className="leading-relaxed">
                Nadine Rau u. Mike Trepte GbR
                <br />
                Bettenhäuserstr. 1
                <br />
                34123 Kassel
                <br />
                Telefon: 0561 / 43027276
                <br />
                E-Mail: nadine.rau@yin-und-klang.de
              </p>

              <p className="leading-relaxed">
                Zur Wahrung der Frist genügt es, dass Sie die Mitteilung vor
                Ablauf der Widerrufsfrist absenden. Sie können dafür das
                untenstehende Formular verwenden, müssen es aber nicht.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-800 mb-4">
                Folgen des Widerrufs
              </h2>

              <p className="leading-relaxed">
                Wir erstatten Ihnen den gezahlten Betrag unverzüglich, spätestens
                binnen vierzehn Tagen ab dem Tag, an dem Ihr Widerruf bei uns
                eingegangen ist. Für die Rückzahlung verwenden wir dasselbe
                Zahlungsmittel wie bei der ursprünglichen Zahlung; Entgelte
                entstehen Ihnen dadurch nicht. Wird der Gutschein auf Ihren
                ausdrücklichen Wunsch bereits innerhalb der Widerrufsfrist
                eingelöst und die Leistung vollständig erbracht, erlischt das
                Widerrufsrecht.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-800 mb-4">
                Muster-Widerrufsformular
              </h2>

              <p className="leading-relaxed">
                Wenn Sie den Vertrag widerrufen möchten, füllen Sie dieses
                Formular aus und senden Sie es an uns zurück.
              </p>

              <p className="leading-relaxed">
                An
                <br />
                Nadine Rau u. Mike Trepte GbR
                <br />
                Bettenhäuserstr. 1
                <br />
                34123 Kassel
                <br />
                nadine.rau@yin-und-klang.de
              </p>

              <p className="leading-relaxed">
                Hiermit widerrufe ich den von mir abgeschlossenen Vertrag über
                den Kauf des folgenden Gutscheins: ________________
              </p>

              <p className="leading-relaxed">
                Bestellt am / erhalten am: ________________
                <br />
                Name: ________________
                <br />
                Anschrift: ________________
                <br />
                Datum und Unterschrift (nur bei Mitteilung auf Papier):
                ________________
              </p>
            </section>
          </div>
        </div>
      </motion.div>
    </div>
  </div>
);

export default RevocationPage;